<script setup lang="ts">
import EditModalContent from "@/components/TenkoAssociations/EditModalContent.vue";
import RegisterModal from "@/components/Common/RegisterModal.vue";
import { useAuth } from "@/services/user/Auth0UserProvider";
import Api from "@/services/api/ApiServiceFabrick";
import { Ref, ref, computed } from 'vue';
import accountType from "@/types/account";
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue', 'success'])
const props = defineProps<{
  modelValue: boolean;
  account: accountType | null;
  employeeCode: string;
  isRegistered: boolean;
}>();

const { loginWithRedirect } = useAuth()
const errors: Ref<{[key: string]: string[]}> = ref({
  employee_cd: [] as string[]
})
const loading: Ref<boolean> = ref(false);
const employeeCd: Ref<string> = ref(setEmployeeCd())

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function setEmployeeCd() {
  return props.employeeCode
}

function createOrUpdateTenkoAssociation() {
  if (props.isRegistered) {
    return updateTenkoAssociation()
  }
  createTenkoAssociation()
}

function createTenkoAssociation() {
  loading.value = true
  const params = makeUpdateParams()
  Api().createTenkoAssociation(params).then(() => {
    loading.value = false
    emits('success');
  }).catch((error) => {
    loading.value = false
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({
          appState: { targetUrl: location.pathname },
        });
        break;
      case 403:
        location.reload();
        break;
      case 422:
        errors.value = res.data.errors;
      }
  })
}

function updateTenkoAssociation() {
  loading.value = true
  const params = makeUpdateParams()
  Api().updateTenkoAssociation(params).then(() => {
    loading.value = false
    emits('success');
  }).catch((error) => {
    loading.value = false
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({
          appState: { targetUrl: location.pathname },
        });
        break;
      case 403:
        location.reload();
        break;
      case 422:
        errors.value = res.data.errors;
      }
  })
}

function makeUpdateParams() {
  return {
    operation_office_id: props.account?.officeable.id,
    driver_id: props.account?.driver_id,
    employee_cd: employeeCd.value
  }
}
</script>
<template>
  <RegisterModal
    v-model="modelValue"
    :title="i18n.global.t('pages.tenkoAssociation.editModal.title')"
    :note="i18n.global.t('common.confirmationModal.confirmDelete')"
    :confirmBtnName="i18n.global.t('common.deleteBtn')"
    confirmBtnClass="bg-danger text-white"
  >
    <template v-slot:content>
      <EditModalContent
        :account="props.account"
        v-model="employeeCd"
        :errors="errors"
      />
    </template>
    <template v-slot:buttons>
      <div class="pt-2">
        <v-btn
          @click="modelValue = false"
          class="reset-btn mr-2"
          :disabled="loading"
          :style="{
            backgroundColor : loading ? '#B3B8BB' : ''
          }"
        >
          {{ i18n.global.t('common.cancelBtn') }}
        </v-btn>
        <v-btn
          @click="createOrUpdateTenkoAssociation"
          class="exec-btn"
          :loading="loading"
        >
          {{ i18n.global.t('common.saveBtn') }}
        </v-btn>
      </div>
    </template>
  </RegisterModal>
</template>
